import React from 'react';
import { LinearProgress } from '@mui/material';
import './ResultsView.css';
import './Explore.css';

const ResultsView = ({ loading, results }) =>
  loading ? (
    <div>
      <br />
      <div> Loading data.... </div>
      <br />
      <LinearProgress color="secondary" />
    </div>
  ) : (
    <div className="grid-container-lg ResultsView-list">
      {results.map((result, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="row ResultsView-list-item" key={index}>
          {result}
        </div>
      ))}
    </div>
  );

export default ResultsView;
